import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";

const getScanDatasetsByFirebaseId = createSelector([
  getDomain
], (domain) => domain.scanDatasets.byFirebaseId);

export default getScanDatasetsByFirebaseId;
